// Unpublished Work © 2023 Deere & Company

import t from 'tcomb';
import {PageStatus} from '../page-status';
import {SaveError} from './save-error';
import {DataShareSaveSuccess} from './data-share-save-success';

export const DataShareApplicationStatus = t.struct({
    canShowCountryServiceError: t.Boolean,
    dataSharePageStatus: PageStatus,
    canResetForm: t.Boolean,
    dataShareSaveError: SaveError,
    dataShareSaveSuccess: DataShareSaveSuccess
}, {
    defaultProps: {
        canShowCountryServiceError: false,
        dataSharePageStatus: PageStatus.meta.map.COMPLETE,
        canResetForm: true,
        dataShareSaveError: SaveError({}),
        dataShareSaveSuccess: DataShareSaveSuccess({})
    },
    name: 'DataShareApplicationStatus',
    strict: true
});
